export const selectReviewsState = (state) => state.reviews;

const selectReviewsConfigByProductId = (state, productId) =>
    state.reviews.reviewsByProductId[productId];

export const selectReviewsByProductId = (state, productId) => {
    const config = selectReviewsConfigByProductId(state, productId);
    const byId = state.reviews.byId;

    if (!config || !config.ids) return [];

    return config.ids.map(id => byId[id]).filter(Boolean);
};

export const selectIsReviewsLoading = (state, productId) => {
    const config = selectReviewsConfigByProductId(state, productId);
    return config ? config.loading : false;
};

export const selectReviewsHasMore = (state, productId) => {
    const config = selectReviewsConfigByProductId(state, productId);
    return config ? config.hasMore : true;
};

export const selectReviewsCurrentPage = (state, productId) => {
    const config = selectReviewsConfigByProductId(state, productId);
    return config ? config.currentPage : 0;
};

export const selectReviewsTotal = (state, productId) => {
    const config = selectReviewsConfigByProductId(state, productId);
    return config ? config.total : 0;
};

export const reviewsSelectors = {
    selectReviewsByProductId,
    selectIsReviewsLoading,
    selectReviewsHasMore,
    selectReviewsCurrentPage,
    selectReviewsTotal,
};

export default reviewsSelectors;